import React from 'react'

const InteriorSeating = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 960 716" xmlSpace="preserve" width={width} height={height}>
    <g>
      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M12,169.887c0,0,35.234-21.151,82.633-48.062c71.875-40.808,176.134-92.469,219.11-108.503"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M385.064,17.095c0,0-124.355,77.339-140.813,86.771s-23.774,16.977-49.376,16.977s-100.241,0.982-100.241,0.982"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M505.761,15.209c0,0-150.872,76.396-154.529,78.282l-2.743,36.783l263.339,2.829l15.544-39.613"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M604.514,450.006c0,0-11.073-86.712,32.003-129.213c42.061-41.499,54.862-82.998,60.349-102.804
		c5.486-19.806,37.489-56.59,73.15-55.646"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M887.055,219.875c-51.117-1.294-93.456,54.493-101.32,81.659c-7.864,27.167-30.72,76.866-86.506,141.009
		c-66.37,76.313-17.908,171.573-17.908,171.573s-228.593-36.783-275.226-32.068c-46.633,4.716-67.664-15.091-59.434-44.328
		c8.229-29.238,21.031-94.316,24.688-106.577c3.657-12.261,27.431-47.158,114.297-25.465s117.954,46.215,117.954,46.215
		l71.321,147.133"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M872.425,173.66c0,0-39.318,19.806-84.122-2.829s-55.777-32.067-60.349-72.623c-4.572-40.556,21.031-66.021,32.917-71.68
		c11.887-5.659,82.294-36.783,96.924-9.432C872.425,44.447,922.715,156.683,872.425,173.66z"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M833.107,7.664c-26.517,4.716-28.346,29.238-30.174,40.556c-1.829,11.318-9.144,78.282,18.287,108.463
		c27.431,30.181,55.777,14.147,55.777,14.147l21.031,13.204"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M703.586,129.562c0,0-20.572,10.363-44.014-1.48c-23.442-11.843-29.183-16.778-31.575-37.998
		C625.605,68.865,639,55.541,645.22,52.58s43.057-19.245,50.712-4.935S729.899,120.679,703.586,129.562z"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M683.014,42.71c-13.874,2.467-14.831,15.298-15.788,21.219c-0.957,5.922-4.784,40.958,9.568,56.75
		c14.352,15.791,29.183,7.402,29.183,7.402l11.003,6.909c0,0,22.859,18.863,10.058,41.499"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M950.147,8.607c0,0-117.954,482.898-305.401,689.45"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M375.92,699c0,0-57.605-55.646-32.003-147.133"
      />

      <line fill="none" stroke={color} strokeWidth="9.3515" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="662.119" y1="14.266" x2="645.22" y2="52.58" />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M561.217,300.041c0.108-18.873,3.275-48.871,20.423-66.785c25.815-26.968,33.672-53.937,37.039-66.808
		c3.367-12.871,23.009-36.775,44.896-36.162"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M404.807,345.199c4.26-14.58,8.654-28.823,10.431-34.781c2.245-7.525,15.714-33.574,69.028-20.26
		c23.498,5.868,41.116,11.782,53.472,16.561"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M722.607,147.701c-31.373-0.841-57.359,35.412-62.185,53.067s-18.855,49.952-53.093,91.636c-1.75,2.131-3.37,4.285-4.868,6.455"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M535.021,385.871c0,0-22.859-54.703-17.373-65.078c5.486-10.375,38.404-30.181,129.841-15.091"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M603.599,386.814c0,0-245.966,0-262.425,0s-51.205-5.659-58.52-49.044"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M12,350.974c0,0,28.346-16.034,50.214-27.879c10.669-5.779,14.706-7.962,25.679-15.507c12.029-8.272,11.887-15.091,9.144-26.408
		c-4.704-19.41,3.778-90.574,79.55-136.758c39.931-24.339,49.037,0.874,50.628,20.721"
      />

      <line fill="none" stroke={color} strokeWidth="9.3515" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="245.165" y1="363.235" x2="12.914" y2="582.048" />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M106.18,498.107c0,0,11.887,27.352,60.349,27.352s179.217,6.602,179.217,6.602"
      />

      <ellipse transform="matrix(0.8994 -0.4371 0.4371 0.8994 -77.2873 160.0269)" fill="none" stroke={color} strokeWidth="9.3515" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="309.076" cy="247.95" rx="57.003" ry="144.998" />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M272.596,220.818c7.315-4.716,9.144-4.716,24.688-5.659c15.544-0.943,28.044-15.552,28.044-15.552
		c-25.946-44.18-53.249-72.15-66.028-65.467c-15.468,8.091-3.797,63.896,26.067,124.644c29.865,60.748,66.615,103.436,82.083,95.345
		c7.51-3.928,8.623-19.102,4.363-40.628c0,0-25.153-24.776-20.581,28.984"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M345.798,238.711c7.362,15.816,13.433,31.139,18.052,45.192c0,0-8.961,4.822-19.933-18.757S345.798,238.711,345.798,238.711z"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M307.342,293.441c0,0,13.716-10.375,20.116,4.716c6.401,15.091,6.401,32.067,6.401,32.067"
      />

      <line fill="none" stroke={color} strokeWidth="9.3515" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="520.391" y1="349.088" x2="391.465" y2="345.315" />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M155.41,398.734c0,0,93.413-28.897,132.731-67.567"
      />

      <path
        fill="none"
        stroke={color}
        strokeWidth="9.3515"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
		M238.888,228.731c0,0-53.653,25.947-77.056,39.741c-44.949,26.494-82.168,67.411-82.168,67.411"
      />
    </g>
  </svg>
)
export default InteriorSeating
